import classNames from "classnames";
import { HIDDEN_LABELS_LIST, OLYMPICS_HIDDEN_LABELS } from "./constants";
import { normalizeClass, isOlympics } from "../../../../utils/path/library";

const createDepartmentsMarkup = (
    baseSection,
    subSection,
    path,
    departments
) => {
    if (!departments.sectionList || !departments.sectionLabels) {
        return null;
    }

    const labels = departments.sectionLabels;

    //Business Logic: some department labels on cards should be hidden based on a few rules defined in shouldLabelBeShown
    const labelsToBeShown = labels.filter((label, index) =>
        shouldLabelBeShown(
            label,
            index,
            baseSection,
            subSection,
            path,
            departments
        )
    );

    const departmentsMarkup = labelsToBeShown.map((item, index) => {
        const className = classNames(
            "departmentItem",
            normalizeClass("deptItem", item, "", true)
        );
        const separator =
            index < labelsToBeShown.length - 1 ? (
                <span className="metaSeparator" aria-hidden="true">
                    -
                </span>
            ) : null;
        return (
            <span className={className} key={item}>
                {item} {separator}
            </span>
        );
    });
    return departmentsMarkup;
};

const shouldLabelBeShown = (
    label,
    index,
    baseSection,
    subSection,
    path,
    departments
) => {
    const sectionForLabel = departments.sectionList[index];

    const showCanadaLabel = () => {
        //if there is only one label and it is canada, show it
        return (
            sectionForLabel === "canada" &&
            departments.sectionLabels.length === 1
        );
    };

    const hideEmptyLabel = () => {
        return !label;
    };

    const hideFirstHiddenLabel = () => {
        return (
            //if the first label is the baseSection, subSection, or in the Hidden label list, hide it
            index === 0 &&
            (sectionForLabel === baseSection ||
                sectionForLabel === subSection ||
                HIDDEN_LABELS_LIST.includes(sectionForLabel))
        );
    };

    const hideOlympicHiddenLabel = () => {
        //if it's an olympic path, and the label is in the hidden list, hide that label
        return (
            isOlympics({ path }) &&
            OLYMPICS_HIDDEN_LABELS.includes(sectionForLabel)
        );
    };

    return (
        showCanadaLabel() ||
        !(
            hideOlympicHiddenLabel() ||
            hideFirstHiddenLabel() ||
            hideEmptyLabel()
        )
    );

    //equivalent to return statement:
    // if(showCanadaLabel()) return true;
    // if(hideOlympicHiddenLabel()) return false;
    // if(hideFirstHiddenLabel()) return false;
    // if(hideEmptyLabel()) return false;
    // return true;
};

export { createDepartmentsMarkup };
